import { ICampaignApplicantFilter, IApplicationCard, IDeclineApplicationRequest } from './../types';
import type {
  ApiResponse,
  IAgentGigCompliance,
  ISaveCommunicationLogPayload,
  IApplicationNotesPayload,
} from '../types';
import routes from '@/config/routes';
import { v3Get, v3Post, v3Put, v3Remove } from '@/api/axios.instance.V3';
import type { ICommunicationLogPayload } from '@/store/types';
import { ICampaignApplicantsCount } from '@/components/client/campaigns/types/types';

const getApplicationStatusCountByCampaignsId = (campaignId: number, searchText: string): ApiResponse => {
  const searchString = searchText ? `?searchString=${searchText}` : '';
  return v3Post(`${routes.backendUrl.application.getApplicationStatusCountByCampaignId}${campaignId}${searchString}`);
};

const getApplicationDetailsStatusCountByCampaignId = (campaignId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.application.getApplicationDetailsStatusCountByCampaignId}${campaignId}`);

const getApplicationDetailsByApplicationId = (ApplicationId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.application.getApplicationDetailsByApplicationId + ApplicationId}`, {
    params: { d: true },
  });

const getCommunicationLogList = (payload: ICommunicationLogPayload): ApiResponse =>
  v3Get(`${routes.backendUrl.application.getCommunicationLogList}`, {
    params: {
      campaignId: payload.campaignId,
      SPUserId: payload.spUserId,
      isCurrentCampaign: payload.isCurrentCampaign,
    },
  });

const getCommunicationTypeList = (): ApiResponse => v3Get(`${routes.backendUrl.application.getCommunicationTypeList}`);

const getCommunicationStatusList = (communicationTypeId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.application.getCommunicationStatusList}/${communicationTypeId}`);

const saveCommmunicationLog = (payload: ISaveCommunicationLogPayload): ApiResponse =>
  v3Post(`${routes.backendUrl.application.saveCommunicationLog}`, payload);

const setApplicationStatusByStatusId = (
  statusId: number,
  applicationId: number,
  currentStatusId?: number,
): ApiResponse =>
  v3Put(`${routes.backendUrl.application.setApplicationStatusByStatusId}`, applicationId, {
    params: { statusId, currentStatusId },
  });

const getApplicationNotesByUserId = (userId: number, campaignId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.application.getApplicationNotesByUserId}${userId}/${campaignId}`);

const saveApplicationNote = (payload: IApplicationNotesPayload): ApiResponse =>
  v3Post(`${routes.backendUrl.application.saveApplicationNote}`, payload);

const deleteApplicationNote = (payload: number): ApiResponse =>
  v3Remove(`${routes.backendUrl.application.deleteApplicationNote}/${payload}`);

const deleteCommunicationLog = (communicationLogId: number): ApiResponse =>
  v3Post(`${routes.backendUrl.application.deleteCommunicationLog}/${communicationLogId}`);

const getAgentGigCompliance = (applicationId: number): ApiResponse<IAgentGigCompliance> =>
  v3Get(`${routes.backendUrl.application.agentGigCompliance}/${applicationId}`);

export const getCampaignApplicantCount = (filter: ICampaignApplicantFilter): ApiResponse<ICampaignApplicantsCount> =>
  v3Post(`${routes.client.campaigns.getCampaignApplicantCount}`, { ...filter });

export const getCampaignApplicantList = (
  applicationSelection: Partial<ICampaignApplicantFilter>,
): ApiResponse<IApplicationCard[]> =>
  v3Post(`${routes.client.campaigns.getCampaignApplicantList}`, applicationSelection);

const getCampaignApplicationEndReasonList = (applicationEndTypeId: number): ApiResponse =>
  v3Get(`${routes.client.campaigns.getCampaignApplicationEndReasonList}?applicationEndTypeId=${applicationEndTypeId}`);

const getApplicationLocktypesList = (): ApiResponse => v3Get(`${routes.client.campaigns.getApplicationLocktypesList}`);

const declineApplication = (declineRequest: IDeclineApplicationRequest): ApiResponse =>
  v3Post(`${routes.client.campaigns.declineApplication}`, declineRequest);

const getApplicationStatusValidation = (applicationId: number, currentApplicationStatusId?: number): ApiResponse =>
  v3Get(
    `${routes.backendUrl.application.getApplicationStatusValidation}/${applicationId}/${currentApplicationStatusId}`,
  );

export const applicationApi = {
  getApplicationDetailsByApplicationId,
  setApplicationStatusByStatusId,
  getApplicationStatusCountByCampaignsId,
  getApplicationDetailsStatusCountByCampaignId,
  getApplicationNotesByUserId,
  saveApplicationNote,
  deleteApplicationNote,
  getCommunicationLogList,
  getCommunicationTypeList,
  getCommunicationStatusList,
  saveCommmunicationLog,
  deleteCommunicationLog,
  getAgentGigCompliance,
  getCampaignApplicationEndReasonList,
  getApplicationLocktypesList,
  declineApplication,
  getApplicationStatusValidation,
};
